import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LibTableComponent } from '@tuain/ng-forms';
import { tuainFormsBaseModules, tuainBaseComponents } from '@components/tuain.modules';
// import { DocumentCustomActionComponent } from './document-custom-action/document-custom-action.component';

@Component({
  standalone: true,
  selector: 'app-request-timeline-table',
  imports: [...tuainFormsBaseModules, ...tuainBaseComponents],
  templateUrl: './request-timeline.html',
  styleUrls: ['./request-timeline.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppRequestTimelineTable extends LibTableComponent {
  cardActions: any = {};

  override start() {
    super.start();
    this.inlineActions.forEach(act => {
      // Esto es para convertir un arreglo en un objeto y accederlo como cardActios.download
      this.cardActions[act.actionCode] = act;
    });
  }
}
